import React, { useState} from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import TextArea from '../UI/Control/InputTextarea';
import { useSelector } from 'react-redux'
import MandatoryLabel from '../UI/Control/MandatoryLabel';
import DateTime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from "moment";
const OnHold = (props) => {

    let taskId = props.taskId;
    const EDCUserID = useSelector(state => state.auth.gValue01);
    const [onHoldDateTime, setOnHoldDateTime] = useState('');

    const SaveOnHold = (event) => {
        if (onHoldDateTime == '') {
            alert('On hold date should not be empty.');
            return false;
        }

      

        let objNotes = document.getElementById('txtNotes');
        if (objNotes.value.trim() == '') {
            alert('Notes should not be empty.');
            objNotes.focus();
            return false;
        }

        let model = {
            TaskID: taskId,
            onHoldDateTime: onHoldDateTime,
            Notes: objNotes.value,
            CreationUser: EDCUserID
        };

        fetch('api/ImageService/SaveOnHold', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.json()).then(res => {
            if (res == -1) {
                alert('Notes not saved, Something went wrong.');
            }
            if (res > 0) {
                props.relaodAction();
            }
        })
    };

    return (
        <div>
            <Row className="mt-2 mb-2">
                <Col md={1}>Date<MandatoryLabel></MandatoryLabel>: </Col>
                <Col md={2}>
                    <DateTime id="txtDateTime" name="txtDateTime" style={{ width: "220px" }} inputProps={{ readOnly: true }} timeFormat={false} dateFormat="DD-MMM-yyyy" isValidDate={(current) => current.isSameOrAfter(moment(), "day")} onChange={(date) => {
                        const formatted = moment(date).format("YYYY-MM-DD HH:mm:ss");
                        setOnHoldDateTime(formatted);
                    }} />
                </Col>
                <Col md={9}></Col>
            </Row>
            <Row className="mt-2 mb-2">
                <Col md={1}>Notes<MandatoryLabel></MandatoryLabel>: </Col>
                <Col md={10}>
                    <TextArea id="txtNotes" rows='5' cols='100' />
                </Col>
                <Col md={1}><Button style={{ marginTop: "90px" }} className="btn-success" onClick={SaveOnHold} > Submit </Button></Col>
            </Row>
        </div>
    );
}
export default OnHold;
